module.exports = __webpack_public_path__ + "img/img_size7_hc.4078dcaa.png";